<template>
  <div v-if="isMobile">
    <app-message
      v-for="index in letters.length"
      :key="index"
      :index="index - 1"
      :item="letters[index - 1]"
      :selectedMessage="selectedMessage"
      @clicked="onClickItem"
      @download="callDownload"
    >
    </app-message>
  </div>
  <div v-else>
    <v-data-table
      :items="letters"
      item-key="LetterID"
      :headers="letterHeaders"
      class="elevation-1 rounded"
      :disable-pagination="true"
      :hide-default-footer="true"
      :no-data-text="tableText"
      show-expand
    >
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <br />
          <b>متن پیام: </b> {{ item.Request }}
          <br />
          <br />
          <b>پاسخ: </b>
          <span v-html="item.Response"></span>
          <span v-html="' '"></span>
          <a v-if="item.HasAttachment" @click="callDownload(item.FSerial)"
            >دریافت مدرک</a
          >
          <br />
          <br />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Message from "./Message";
import { downloadAttach } from "@/api/ertebat";
import { saveByteArray } from "@/utils/constants";

export default {
  created() {
    this.$store.dispatch("getErtebatMessages");
  },
  components: {
    appMessage: Message,
  },
  computed: {
    letters() {
      return this.$store.getters.letters;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  data() {
    return {
      selectedMessage: -1,
      letterHeaders: [
        {
          text: "شماره درخواست",
          value: "FSerial",
          width: "8%",
        },
        {
          text: "شماره نامه",
          value: "LetterID",
          width: "8%",
        },
        {
          text: "وضعیت",
          value: "Status",
          width: "15%",
        },
        {
          text: "گيرنده",
          value: "Girandeh",
          width: "34%",
        },
        {
          text: "موضوع",
          value: "Subject",
          width: "30%",
        },
        {
          text: "تاریخ ارسال",
          value: "DSend",
          width: "5%",
        },

        { text: "جزییات", value: "data-table-expand" },
      ],
    };
  },

  methods: {
    onClickItem(index) {
      if (this.selectedMessage == index) {
        this.selectedMessage = -1;
      } else {
        this.selectedMessage = index;
      }
    },
    callDownload(index) {
      this.$store.commit("SET_PROGRESS_SHOW", true);
      downloadAttach(index)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_PROGRESS_SHOW", false);
          if (data.Success) {
            saveByteArray(data.Array, data.fileName);
          } else {
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
};
</script>
<style scoped></style>
